import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isInline", "className", "style"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className", "children", "onUpdate", "onChange", "field", "value"];
import * as React from 'react';
import cn from 'classnames';
import { noop } from 'lodash';
import { safeInvoke } from '../../../../library';
var choiceClasses = {
  "switch": 'switches',
  checkbox: 'checkboxes',
  radio: 'radios'
};
export var ChoiceGroupContext = React.createContext({
  onChange: noop
});
var ChoiceGroup = function ChoiceGroup(props) {
  var isInline = props.isInline,
    className = props.className,
    style = props.style,
    pass = _objectWithoutProperties(props, _excluded);
  var classNames = cn({
    '-inline': props.isInline
  }, className);
  return React.createElement("div", {
    className: classNames,
    style: style
  }, React.createElement(ChoiceGroupContext.Provider, {
    value: {
      onChange: props.onChange,
      isDisabled: props.isDisabled,
      isReadOnly: props.isReadOnly,
      size: props.size
    }
  }, props.children));
};
export var SwitchGroup = function SwitchGroup(props) {
  var className = props.className,
    pass = _objectWithoutProperties(props, _excluded2);
  return React.createElement(ChoiceGroup, _extends({
    className: cn(choiceClasses["switch"], className)
  }, pass));
};
export var CheckboxGroup = function CheckboxGroup(props) {
  var className = props.className,
    pass = _objectWithoutProperties(props, _excluded3);
  return React.createElement(ChoiceGroup, _extends({
    className: cn(choiceClasses.checkbox, className)
  }, pass));
};
export var RadioGroupContext = React.createContext({
  activeValue: null,
  name: 'radio'
});
export var RadioGroup = function RadioGroup(props) {
  var className = props.className,
    children = props.children,
    onUpdate = props.onUpdate,
    onChange = props.onChange,
    field = props.field,
    value = props.value,
    pass = _objectWithoutProperties(props, _excluded4);
  function handleChange(e) {
    var value = e.target.value;
    safeInvoke(onUpdate, field, value, e);
    safeInvoke(onChange, e);
  }
  return React.createElement(ChoiceGroup, _extends({
    className: cn(choiceClasses.radio, className),
    onChange: handleChange
  }, pass), React.createElement(RadioGroupContext.Provider, {
    value: {
      activeValue: value !== null && value !== void 0 ? value : null,
      name: field
    }
  }, children));
};